var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 658,
    height: 658,
    viewBox: "0 0 658 658",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_12365_2669)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328.942,
    cy: 328.942,
    r: 118.942,
    stroke: "#FF8946",
    strokeWidth: 40
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 328.942,
    cy: 328.942,
    r: 98.9419,
    fill: "#FFC700",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_12365_2669",
    x: 0,
    y: 0,
    width: 657.884,
    height: 657.885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 95,
    result: "effect1_foregroundBlur_12365_2669"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardbg);
export default __webpack_public_path__ + "static/media/rewardbg.eb038c1bf8ef9acfd25ef236a66dac27.svg";
export { ForwardRef as ReactComponent };